import * as React from "react";
import styled from "styled-components";
import { Route, Switch, Redirect } from "react-router-dom";
import { ReactSVG } from "react-svg";
import { Container } from "src/components/Container";
import { Box } from "src/components/Box";
import { MediaQueries } from "src/constants";
import { PASSPORT_ROUTES } from "src/constants/routes";
import { PassportAssets } from "src/assets";
import {
  PassportEntityTypeScreen,
  PassportFormsScreen,
  PassportOnboardingCompletedScreen,
} from "src/modules/screens";
import { LanguageSwitcher } from "src/components/LanguageSwitcher";
import { usePassportStore } from "src/stores/Passport.store";

const pillarSvgUrl = require("src/assets/images/pillar.svg");

const ContainerEl = styled(Container)`
  min-height: ${(p) => p.theme.viewHeight};
  margin: 0 auto;
  max-width: 1200px;
  // Setting the background directly in the styles causes an error in the test suite.
  // We have to define the URL in the style prop in <ContainerEl style={} />
  // hide it on mobile by using position -20000 and correct position in the media query below
  background-position: bottom -20000px left -92px;
  background-repeat: no-repeat;

  ${MediaQueries.screen.large.minWidth} {
    background-position: bottom -200px left -92px;
    padding-bottom: 144px;
  }

  label {
    line-height: 22px;
  }

  font-family: Poppins-Regular, sans-serif;
`;

const BannerEl = styled(Box)`
  margin-bottom: 32px;
  ${MediaQueries.screen.large.minWidth} {
    margin: 32px 0 48px;
  }
`;

export const PassportContainer = () => {
  const { authUser } = usePassportStore();

  return (
    <ContainerEl
      overflowYScroll
      style={{ backgroundImage: `url(${pillarSvgUrl})` }}
    >
      <Switch>
        <Route path={PASSPORT_ROUTES.onboardingCompleted}>
          <BannerEl textCenter flex alignItemsCenter justifyBetween>
            <ReactSVG src={PassportAssets.midtransLogo} />
            <LanguageSwitcher defaultLanguage={authUser.json?.language!} />
          </BannerEl>
          <PassportOnboardingCompletedScreen />
        </Route>
        <Route path="/">
          <BannerEl flex alignItemsCenter justifyBetween>
            <ReactSVG src={PassportAssets.midtransLogo} />
            <LanguageSwitcher defaultLanguage={authUser.json?.language!} />
          </BannerEl>
          <Switch>
            <Route exact path="/">
              <Redirect to={PASSPORT_ROUTES.entityType} />
            </Route>
            <Route path={PASSPORT_ROUTES.entityType}>
              <PassportEntityTypeScreen />
            </Route>
            <Route path="/">
              <PassportFormsScreen />
            </Route>
          </Switch>
        </Route>
        <Route>
          <Redirect to="/" />
        </Route>
      </Switch>
    </ContainerEl>
  );
};
